import type { EffectCallback } from "react";
import { useEffect, useRef } from "react";

export function useEffectOnce(effect: EffectCallback) {
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        return effect();
    }, []);
}
